
import React, { useState, useEffect } from "react";
import Header from "./Header";
import Navbar1 from "./Navbar";
import axios from "axios";
import { getBaseUrl } from "../api";

function Insulin() {
  const [content, setContent] = useState("");
  const [error, setError] = useState("");
  const baseUrl = getBaseUrl();
  useEffect(() => {
    axios
      .get(`https://${baseUrl}/Dial-insulin.html`)
      .then((response) => {
        setContent(response.data);
      })
      .catch((err) => {
        console.error("Error fetching insulin instructions:", err);
        setError("Failed to load content. Please try again later.");
      });
  }, []);

  return (
    <>
      <Header />
      <Navbar1 />
      <p style={{ fontSize: "30px", fontWeight: "bold", textAlign: "center" }}>
        How to Use Insulin
      </p>

      {error ? (
        <p style={{ color: "red", textAlign: "center" }}>{error}</p>
      ) : (
        <div
          style={{
            padding: "20px",
            fontSize: "16px",
            textAlign: "justify",
            lineHeight: "1.8",
          }}
          dangerouslySetInnerHTML={{ __html: content }} // ✅ Render HTML tags
        />
      )}
    </>
  );
}

export default Insulin;